import type { Refusal } from '../model';
import { actionLabel, refusalCopy } from '../refusals';

/**
 * One refused sheet, explained (F7).
 *
 * The solver's own sentence comes first and is never paraphrased: it carries
 * the measured numbers and it is the authority. Around it goes a title that
 * can be read from across a workshop and the steps to try, which is the part
 * a message cannot give.
 *
 * The steps carry a heading. Without one they read as more explanation, and an
 * operator who has just been told the sheet is refused is looking for the
 * instruction, not for more prose. The code is last and small: it is there for
 * the phone call that this panel is meant to prevent.
 *
 * `stop` is styled differently from `reshoot` on purpose. The whole point of
 * the distinction is that one of them means "thirty seconds" and the other
 * means "put the phone down and look at the bed".
 */
export function RefusalPanel({ refusal }: { refusal: Refusal }) {
  const copy = refusalCopy(refusal);
  const stop = refusal.action === 'stop';

  return (
    <div className={`panel ${stop ? 'stop' : 'reshoot'}`}>
      <h3>{copy.title}</h3>
      {/* Text, not a pill: as a pill it read as a button (SLD-0004). */}
      <p className={`refusal-action ${stop ? 'action-stop' : 'action-reshoot'}`}>
        Recommended action: <strong>{actionLabel(refusal.action)}</strong>
      </p>
      <p className="refusal-message">{refusal.message}</p>
      <h4 className="steps-head">What to do</h4>
      <ol className="steps">
        {copy.steps.map((step) => <li key={step}>{step}</li>)}
      </ol>
      <p className="muted code">Reference: {refusal.code}</p>
    </div>
  );
}
